<template>
  <div v-if="hasAssociate" class="support-wrapper">
    <a-tooltip v-if="collapsed" title="Ask Support" placement="right">
      <button type="button" class="support-entry support-entry--collapsed" data-testid="layout-support-entry"
        @click="openChat">
        <span class="support-entry__icon">
          <a-icon icon="carbon:help" width="18" height="18" />
        </span>
      </button>
    </a-tooltip>
    <button v-else type="button" class="support-entry" data-testid="layout-support-entry" @click="openChat">
      <span class="support-entry__icon">
        <a-icon icon="carbon:help" width="18" height="18" />
      </span>
      <span class="support-entry__text">
        <span class="support-entry__question">Need help with ePeople?</span>
        <span class="support-entry__action">Ask Support &xrarr;</span>
      </span>
    </button>
  </div>
</template>

<script>
import { Tooltip } from 'ant-design-vue'
import { openSupport } from '@/services/support-diagnostics'

export default {
  name: 'LayoutSupportEntry',
  components: { 'a-tooltip': Tooltip },
  props: {
    collapsed: { type: Boolean, default: false }
  },
  computed: {
    hasAssociate() {
      return Boolean(this.$store.state.applicationState.associate?.id)
    }
  },
  methods: {
    openChat() {
      openSupport()
    }
  }
}
</script>

<style scoped>
.support-wrapper {
  margin: 6px 12px;
}

.support-entry {
  display: flex;
  align-items: center;
  text-align: left;
  width: 100%;
  gap: 10px;
  padding: 10px 11px;
  background: var(--bg-dropdown-selected);
  color: var(--text-color);
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color-base);
  transition: all 0.2s ease;
  font-family: inherit;
  cursor: pointer;
}

.support-entry--collapsed {
  justify-content: center;
  width: 46px;
  height: 46px;
  padding: 0;
  margin: 0 auto;
}

.support-entry__icon {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--border-radius);
  background: var(--bg-component);
  color: var(--primary-color);
  transition: all 0.2s ease;
}

.support-entry__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.support-entry__question {
  color: inherit;
  font-size: 13px;
}

.support-entry__action {
  font-weight: 700;
  color: var(--primary-color);
  font-size: 15px;
  transition: all 0.2s ease;
}

.support-entry:hover,
.support-entry:focus-visible {
  background: var(--primary-color);
  color: #fff;
}

.support-entry:hover .support-entry__icon,
.support-entry:focus-visible .support-entry__icon {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.support-entry:hover .support-entry__action,
.support-entry:focus-visible .support-entry__action {
  color: #fff;
}
</style>
